module.exports = __webpack_public_path__ + "static/media/First-Digital-Mattress-Tag.a9a94d25.jpg";